import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { ChecklistServicoLiberacaoCadastroForm, defaultChecklistServicoLiberacaoCadastroForm, ChecklistServicoLiberacaoCadastroSchema } from "../../../schemas/ChecklistServicoLiberacao_lista/checklistServicoLiberacaoCadastro";
import { ChecklistServicoLiberacao } from "../../../../domain/models/checklist_servico_liberacao";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import PrimaryButton from "../../../../../../common/components/primary_button";


type props = {
  open: boolean,
  saving: boolean,
  loading: boolean,
  selectedChecklistServicoLiberacao?: ChecklistServicoLiberacao | null,
  onClose: () => void,
  onSubmit: (form: ChecklistServicoLiberacaoCadastroForm) => void,
  onOpenChangeHistory: (idTabela: number | null, tipoTabela: LogTipoTabela | null) => void
}

export const CadastroChecklistServicoLiberacaoModal = ({
  open,
  saving,
  loading,
  selectedChecklistServicoLiberacao,
  onClose,
  onSubmit,
  onOpenChangeHistory,
}: props) => {
  const hookFormCadastro = useForm<ChecklistServicoLiberacaoCadastroForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    defaultValues: defaultChecklistServicoLiberacaoCadastroForm,
    resolver: zodResolver(ChecklistServicoLiberacaoCadastroSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedChecklistServicoLiberacao) {
        hookFormCadastro.setValue('idChecklistServico', selectedChecklistServicoLiberacao.idChecklistServico ?? 0);
        hookFormCadastro.setValue('ordem', selectedChecklistServicoLiberacao.ordem ?? '');
        hookFormCadastro.setValue('descricao', selectedChecklistServicoLiberacao.descricao ?? '');
      } else {
        hookFormCadastro.reset(defaultChecklistServicoLiberacaoCadastroForm);
      }
    }
  }, [
    selectedChecklistServicoLiberacao,
    open,
    hookFormCadastro
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Cadastro de Checklist"
      cancelButtonLabel="Fechar"
      leftButtonSlot={
        selectedChecklistServicoLiberacao &&
        <PrimaryButton
          buttonColor="yellow"
          onClick={() => {
            if (selectedChecklistServicoLiberacao) {
              onOpenChangeHistory(
                selectedChecklistServicoLiberacao.idChecklistServicoLiberacao ?? null,
                LogTipoTabela.CHECKLIST_SERVICO_LIBERACAO
              );
            }
          }}>
          <span className="text-xs">
            Historico de alterações
          </span>
        </PrimaryButton>
      }
      onClose={onClose}
      onSubmit={hookFormCadastro.handleSubmit(onSubmit)}>

      <FormContainer title={"Informações"} arrangement="fullRow">
        <>
          <DefaultFormInput
            name='ordem'
            label='Ordem'
            readOnly={false}
            required={true}
            reactHookForm={hookFormCadastro}
          />

          <DefaultFormInput
            name={'descricao'}
            label="Descrição"
            readOnly={false}
            required={true}
            multiline={true}
            rows={5}
            reactHookForm={hookFormCadastro}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}